<template>
	<!-- 只有招商大脑才展示，Sam说其他版本会有新的视频和叫法 -->
	<div class="pr-7" v-show="curWebsite.type == 1 || curWebsite.type == 8 || curWebsite.type == 9">
		<p v-for="list in vedioList" :key="list.type" v-if=" list.type == type"><span class="orgfont">{{list.label}} </span><span @click="geturl(list.sketchUrl)" class="dispaly-inlineblock mx-3 curp"> 简述> </span>  <span @click="geturl(list.expoundUrl)" class="curp">详解></span> </p>
	</div>
</template>

<script>
export default {
  name: "vedio-tips",
  data() {
	return {
		curWebsite: this.$api.getWebsiteType(),
		vedioList: [
			{type: 1,label: "怎么查看企业投资动态？如何分析企业投资趋势？",sketchUrl:"https://share.plvideo.cn/front/video/preview?vid=44796099a4b7ff18aef2c5a54c31b70e_4",expoundUrl:'https://share.plvideo.cn/front/video/view?vid=44796099a4f3f0ffcd3e66dd16d32004_4'},
			{type: 2,label: "产业链招商，怎么快速找到目标企业？",sketchUrl:"https://share.plvideo.cn/front/video/preview?vid=44796099a45c184373e6e071ede7beaa_4",expoundUrl:'https://share.plvideo.cn/front/video/view?vid=44796099a4e5574069804d287611d081_4'},
			{type: 3,label: "驻点招商，怎么快速找到目标企业？",sketchUrl:"https://share.plvideo.cn/front/video/preview?vid=44796099a4f11aa149875d85913fb208_4",expoundUrl:'https://share.plvideo.cn/front/video/view?vid=44796099a4bd4cdcd3e7fd2033b08f38_4'},
			{type: 4,label: "资本招商，怎么快速找到目标企业？",sketchUrl:"https://share.plvideo.cn/front/video/preview?vid=44796099a45cb8b626f9010cd4659265_4",expoundUrl:'https://share.plvideo.cn/front/video/view?vid=44796099a46c9f02f9a78b10e38a8b60_4'},
			{type: 5,label: "怎么判断企业的投资意向？",sketchUrl:"https://share.plvideo.cn/front/video/preview?vid=44796099a4fcbe900c2f6ceeef80c3a6_4",expoundUrl:'https://share.plvideo.cn/front/video/view?vid=44796099a48822d3433a25887ea08ed0_4'},
			{type: 6,label: "怎么判断企业的投资实力？",sketchUrl:"https://share.plvideo.cn/front/video/preview?vid=44796099a4fa8a2109870a4a6fe903b4_4",expoundUrl:'https://share.plvideo.cn/front/video/view?vid=44796099a42f92ea911687d102490814_4'},
			{type: 7,label: "以商招商，怎么与企业快速建立联系？",sketchUrl:"https://share.plvideo.cn/front/video/preview?vid=44796099a4cb61138534333984417821_4",expoundUrl:'https://share.plvideo.cn/front/video/view?vid=44796099a4915ce520dbad62c713800b_4'},
			{type: 8,label: "以商招商，怎么与企业快速建立联系？",sketchUrl:"https://share.plvideo.cn/front/video/preview?vid=44796099a49204b15601b7e33d4cb4d5_4",expoundUrl:'https://share.plvideo.cn/front/video/view?vid=44796099a4665fd41e40dfbb7c50ecc9_4'},
		],
	};  
  },
  props: {
    type: {
			type: Number,
			default: 1, 
			/*1为企业详情页供应商客户表格背景 2为拿地信息表格 3投资项目表格 4融资项目 5.对外投资 6.控制企业 7.专利信息8.软件著作权9.资质证书 10裁判文书 11司法案件 
			14为白色背景15.以商招商列表页 16.企业-城市关系计算器（本地关联企业）列表 17.企业-城市关系计算器（一级关系圈）列表 18.企业-城市关系计算器（二级关系圈计算结果）列表
			19.协会 20.商会 21.专业镇 22.股东信息 23.企业详情的相同投资机构 24.相同协会 25.相同商会 26.本地投资趋势 27.外商投资趋势
			*/
		},
  },
  methods: {
	geturl(url) { 
				 // 构建特征字符串
				  const features = [
				    `width=800`,
				    `height=500`,
				    'top=0',
				    'left=0',
				    'toolbar=no',
				    'menubar=no',
				    'scrollbars=yes',
				    'resizable=yes',
				    'location=no',
				    'status=no'
				  ].join(',');
				 
				  // 打开窗口
				  // window.open(url, '_blank', features);
				window.open(url,'_blank', features); //'https://share.plvideo.cn/front/video'+url
				},
  }
};
</script>

<style>
</style>
